import { Module } from '../../types'

export const createCardFrictionlessFlowNoECardMobileConfiguration =
  (): Module[] => {
    return [
      {
        __typename: 'ModuleTwoColumnProductHeading',
        left: [{ __typename: 'ModuleHeading' }],
        right: [{ __typename: 'ModulePills', show: 'primary only' }],
      },
      { __typename: 'ModuleImages' },
      { __typename: 'ModuleMemberPricingHeader' },
      { __typename: 'ModuleFromPriceFrictionless' },
      { __typename: 'ModuleProductDetails' },
      { __typename: 'ModuleButtons' },
    ]
  }
